<template lang="pug">
	section#inscrever
		.wrapper
			.passos
				h1 JÁ SABE COMO SE INSCREVER? 
					span SIGA OS PASSOS.
				p(data-index="1") Acesse o site: #[strong #[a(href="https://prouniportal.mec.gov.br" target="_blank") Prouniportal.mec.gov.br]]
				p(data-index="2") Vá em #[strong INSCREVA-SE], complete todas as informações de dados pessoais e, na hora de selecionar a instituição de ensino, procure por #[strong.breakLine CENTRO UNIVERSITÁRIO UNIFAEL.]
				p(data-index="3") Agora é só aguardar o resultado. #[strong Boa sorte!]
			img(src="@images/prouniHome/personagem-full.png")
</template>

<script>
export default {
	name: "section-inscrever"
}
</script>

<style lang="stylus" scoped src="./Inscrever.styl"></style>
